<template>
  <div v-if="visibleCertificateList">
    <div>
      <b-row v-if="downloadClicked">
        <b-col><b-progress :value="downloadValue" :max="downloadMax" show-progress animated></b-progress></b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col v-if="isFinanceAdmin" lg="1" sm="12">
          <input
            :checked="allSelected"
            :disabled="isDisabled"
            @click="selectAll"
            class="allimage"
            type="checkbox"
            id="scales"
          />
          <label for="scales" class="px-2">Select all </label>
        </b-col>
        <b-col v-if="isFinanceAdmin" lg="2" sm="12" class="px-0">
          <b-overlay
            :show="downloadClicked"
            rounded
            opacity="0.6"
            spinner-small
            spinner-variant="success"
            class="d-inline-block"
          >
            <b-button
              data-v-step="4"
              :disabled="selectedCertificates.length < 1"
              @click="downloadBulk"
              size="sm"
              :class="{
                'box-shadow2 btn btn-success mr-2': !isDarkMode,
                'btn btn-primary text-light mr-2': isDarkMode
              }"
            >
              <font-awesome-icon :icon="['fas', 'download']" class="mr-1" />Download Certificate
            </b-button>
          </b-overlay>
        </b-col>
        <b-col v-if="isAccountant" lg="2" sm="12">
          <b-button
            data-v-step="4"
            @click="createCertificate"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />Create Certificate
          </b-button>
        </b-col>
        <b-col v-if="isFinanceAdmin || isAdmin" lg="2" sm="12" class="px-0">
          <b-button
            data-v-step="4"
            @click="uploadCertificate"
            size="sm"
            :class="{
              'box-shadow2 btn btn-success mr-2': !isDarkMode,
              'btn btn-primary text-light mr-2': isDarkMode
            }"
          >
            <font-awesome-icon :icon="['fas', 'upload']" class="mr-1" />Upload Certificate
          </b-button>
        </b-col>
      </b-row>
      <div>
        <div>
          <div
            :class="{
              ' my-4 rounded': !isDarkMode,
              '  my-4 bg-dark rounded text-light': isDarkMode
            }"
          >
            <div>
              <div
                :class="{
                  'box-shadow2 my-3': !isDarkMode,
                  ' my-3': isDarkMode
                }"
              >
                <div
                  :class="{
                    'table-row table-row-header text-center': !isDarkMode,
                    'table-row-dark text-center dark-div border-top': isDarkMode
                  }"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column bg-light': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    {{ column.headerText }}
                  </div>
                </div>
                <b-overlay v-if="loading" show :variant="isDarkMode ? 'outline-light' : 'outline-secondary'">
                  <div
                    :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
                  >
                    <div
                      :class="{
                        'table-column table-column-full text-center': !isDarkMode,
                        'table-column-dark table-column-full text-center': isDarkMode
                      }"
                    >
                    </div>
                  </div>
                </b-overlay>
                <div
                  :class="{
                    'table-row text-center ': !isDarkMode,
                    'table-row-dark text-center': isDarkMode
                  }"
                  v-for="(row, index) in rows"
                  :key="row.id"
                >
                  <div
                    v-for="column in columns"
                    :key="column.id"
                    :class="{ 'table-column': !isDarkMode, 'table-column-dark': isDarkMode }"
                    :style="columnStyle(column)"
                  >
                    <slot v-if="column.slotKey" :name="column.slotKey" v-bind:row="row"></slot>
                    <div v-if="column.htmlKey" v-html="row[column.htmlKey]"></div>
                    <div v-if="column.urlKey"
                      ><a :href="row[column.urlKey]" target="_blank">{{ row[column.urlKey] }}</a></div
                    >
                    <div v-if="column.textKey === 'mainCash'">
                      <div v-for="cash in row.mainCash" :key="cash._id">
                        <span class="span-text"><span class="bold">Actual:</span> {{ cash.actualCash }}</span>
                        <br />
                        <span class="span-text"
                          ><span class="bold">Total:</span> {{ calculateDenominationSum(cash.denomination) }}</span
                        ><br />
                        <span class="span-text"><span class="bold">Difference:</span> {{ cash.difference }}</span>
                        <br />
                        <span class="span-text"><span class="bold">Remarks:</span> {{ cash.remarks }}</span>
                      </div>
                    </div>
                    <div v-if="column.textKey === 'onlineCash'">
                      <div v-for="cash in row.onlineCash" :key="cash._id">
                        <span class="span-text"><span class="bold">Actual:</span> {{ cash.actualCash }}</span>
                        <br />
                        <span class="span-text"
                          ><span class="bold">Total:</span> {{ calculateDenominationSum(cash.denomination) }}</span
                        ><br />
                        <span class="span-text"><span class="bold">Difference:</span> {{ cash.difference }}</span>
                        <br />
                        <span class="span-text"><span class="bold">Remarks:</span> {{ cash.remarks }}</span>
                      </div>
                    </div>
                    <div v-if="column.textKey === 'floatCash'">
                      <div v-for="cash in row.floatCash" :key="cash._id">
                        <span class="span-text"><span class="bold">Actual:</span> {{ cash.actualCash }}</span>
                        <br />
                        <span class="span-text"
                          ><span class="bold">Total:</span> {{ calculateDenominationSum(cash.denomination) }}</span
                        ><br />
                        <span class="span-text"><span class="bold">Difference:</span> {{ cash.difference }}</span>
                        <br />
                        <span class="span-text"><span class="bold">Remarks:</span> {{ cash.remarks }}</span>
                      </div>
                    </div>
                    <div v-if="column.textKey === 'pettyCash'">
                      <div v-for="cash in row.pettyCash" :key="cash._id">
                        <span class="span-text"><span class="bold">Actual:</span> {{ cash.actualCash }}</span>
                        <br />
                        <span class="span-text"
                          ><span class="bold">Total:</span> {{ calculateDenominationSum(cash.denomination) }}</span
                        ><br />
                        <span class="span-text"><span class="bold">Difference:</span> {{ cash.difference }}</span>
                        <br />
                        <span class="span-text"><span class="bold">Remarks:</span> {{ cash.remarks }}</span>
                      </div>
                    </div>
                    <div v-if="column.textKey === 'index'">
                      <span class="span-text">{{ index + 1 }}</span>
                    </div>
                    <div v-if="column.textKey === 'select' && isFinanceAdmin">
                      <span class="span-text">
                        <input
                          class="checkbox2"
                          type="checkbox"
                          :checked="selectedCertificates.includes(row)"
                          @click="select(row)"
                      /></span>
                    </div>
                    <div v-if="column.textKey === 'currentStatus'">
                      <span class="span-text">{{ capitalize(row[column.textKey]) }}</span>
                    </div>
                    <div
                      v-if="
                        column.textKey !== 'mainCash' &&
                        column.textKey !== 'onlineCash' &&
                        column.textKey !== 'floatCash' &&
                        column.textKey !== 'pettyCash' &&
                        column.textKey !== 'currentStatus'
                      "
                    >
                      <span class="span-text">{{ row[column.textKey] }}</span>
                    </div>
                    <div v-if="column.textKey === 'functions'">
                      <!-- <div v-if="isSsm || isFinanceAdmin">
                        <span
                          ><b-button :disabled="isAdmin" @click="handleApprove(row)" variant="outline-success"
                            >Approve</b-button
                          ></span
                        >
                        <span class="ml-2"
                          ><b-button :disabled="isAdmin" @click="handleReject(row)" variant="outline-danger"
                            >Reject</b-button
                          ></span
                        >
                      </div> -->
                      <div class="mt-2">
                        <span
                          ><b-button
                            size="sm"
                            :disabled="isAdmin"
                            @click="handleView(row)"
                            :variant="isDarkMode ? 'outline-info' : 'info'"
                          >
                            <font-awesome-icon :icon="['fas', 'edit']" class="mr-1" /></b-button
                        ></span>
                        <span v-if="isFinanceAdmin">
                          <b-button
                            class="ml-1"
                            size="sm"
                            :disabled="isAdmin"
                            @click="handleDownload(row)"
                            :variant="isDarkMode ? 'outline-warning' : 'warning'"
                            ><font-awesome-icon :icon="['fas', 'download']" class="mr-1" /></b-button
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="rows.length === 0"
                  :class="{ 'table-row table-row-empty': !isDarkMode, 'table-row-dark table-row-empty': isDarkMode }"
                >
                  <div
                    :class="{
                      'table-column table-column-full text-center': !isDarkMode,
                      'table-column-dark table-column-full text-center': isDarkMode
                    }"
                    >{{ emptyText }}</div
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-row class="table-bottom-wrapper mt-2 mx-0">
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12"> </b-col>
        <b-col lg="3" sm="12" v-if="showPagination">
          <div class="d-flex justify-content-end">
            <b-pagination-nav
              data-v-step="7"
              v-if="rows.length"
              v-model="currentPage"
              :link-gen="linkGen"
              :number-of-pages="totalNumberOfPage ? totalNumberOfPage : 1"
              use-router
              no-page-detect
              align="right"
              :class="{ '': !isDarkMode, 'dark-nav': isDarkMode }"
            ></b-pagination-nav>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import router from '@/router';

export default {
  name: 'PettyCashCertificateList',
  props: {
    visibleCertificateList: Boolean,
    columns: Array,
    rows: Array,
    loading: Boolean,
    showPagination: Boolean,
    downloadClicked: Boolean,
    pagination: Object,
    downloadMax: Number,
    downloadValue: Number
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        }
      ]
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('darkMode', ['isDarkMode']),
    currentPage() {
      if (this.pagination.page) {
        return this.pagination.page;
      }
      return 1;
    },
    totalNumberOfPage() {
      if (this.pagination) {
        if (this.pagination.total_rows && this.pagination.page_size) {
          return Math.ceil(this.pagination.total_rows / this.pagination.page_size);
        }
      }
      return 0;
    },
    totalCount() {
      if (this.pagination) {
        return this.pagination.total_rows;
      }
      return 0;
    },
    metaDescription() {
      return 'Petty cash Certificate List';
    }
  },
  data() {
    return {
      isAdmin: false,
      isFinanceAdmin: false,
      isSsm: false,
      emptyText: 'no data found',
      isAccountant: false,
      selectedCertificates: [],
      allSelected: false,
      isDisabled: false
    };
  },
  mounted() {
    if (this.user && this.user.roles) {
      this.user.roles.map(item => {
        if (item.name === 'FINANCE_ADMIN') {
          this.isFinanceAdmin = true;
        }
        if (item.name === 'ACCOUNTANT') {
          this.isAccountant = true;
        }
        if (item.name === 'STORE_SALES_MANAGER') {
          this.isSsm = true;
        }
        if (item.name === 'ADMIN') {
          this.isAdmin = true;
        }
      });
    }
  },
  methods: {
    capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },
    selectAll() {
      if (this.allSelected) {
        this.selectedCertificates = [];
        this.allSelected = false;
      } else {
        this.selectedCertificates = this.rows;
        this.allSelected = true;
      }
    },
    select(row) {
      this.allSelected = false;
      if (this.selectedCertificates.includes(row)) {
        this.selectedCertificates = this.selectedCertificates.filter(i => i !== row);
      } else {
        this.selectedCertificates = [...this.selectedCertificates, row];
      }
    },
    calculateDenominationSum(denominations) {
      return denominations.reduce((sum, denom) => {
        const [left, right] = denom.split(':::').map(Number);
        return sum + left * right;
      }, 0);
    },
    createCertificate() {
      router.push('/petty-cash/certificate/new');
    },
    uploadCertificate() {
      router.push('/petty-cash/certificate/cc/upload');
    },
    columnStyle(column) {
      return { width: column.width };
    },
    handleDownload(row) {
      this.$emit('downloadCertificate', { row });
    },
    downloadBulk() {
      this.$emit('downloadBulk', this.selectedCertificates);
    },
    handleView(row) {
      this.$emit('edit', { row });
    },
    handleApprove(row) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: 'green',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Approve it!',
        preConfirm: () => {
          this.$emit('approve', { row });
        },
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });
    },
    handleReject(row) {
      Vue.swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this.",
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, reject it!',
        input: 'text',
        inputValue: '',
        preConfirm: inputValue => {
          if (inputValue) {
            row.rejectedRemarks = inputValue;
            this.$emit('reject', { row });
          }
        },
        background: this.isDarkMode ? '#464d54' : '#ffffff',
        customClass: {
          title: this.isDarkMode ? 'text-light' : 'text-dark',
          content: this.isDarkMode ? 'text-light' : 'text-dark'
        }
      });
    },
    linkGen(pageNum) {
      return { path: this.baseUrl, query: { ...this.$route.query, page: pageNum } };
    }
  }
};
</script>

<style src="../../../assets/css/Table.css"></style>
<style>
.bold {
  font-weight: bolder;
}
</style>
